import { useEffect } from "react"
import { DadosEmpresaCaixa, ResumoRecebimento, ResumoVendas, SangriaSuprimento } from "../../../Utils/Types"
import moment from "moment"
import { Funcoes } from "../../../Utils/Funcoes"

export type Props = {
    visible: boolean,
    empresa: DadosEmpresaCaixa,
    supSangria: SangriaSuprimento[],
    resVendas: ResumoVendas[],
    resRecebimentos: ResumoRecebimento[],
    totSuprimentos: number,
    totDinheiroVendas: number,
    totDinheiroRecebimentos: number,
    totSangrias: number,
    totGeralSupSangria: number,
    totGeralVendas: number,
    totGeralRecebimentos: number,
    totGeralApuracao: number,
    data: string,
    closeModalEvent: () => void
}

export const ReportCaixaBobina = ({ visible, empresa, supSangria, resVendas, resRecebimentos, totSuprimentos, totDinheiroVendas, totDinheiroRecebimentos, totSangrias, totGeralSupSangria, totGeralVendas, totGeralRecebimentos, totGeralApuracao, data, closeModalEvent }: Props) => {

    useEffect(() => {

        if (visible) {

            let modal = document.getElementById('modal_caixa_report_bobina')
            let modalContent = document.getElementById('modal_content_caixa_report_bobina')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-2000px]')
                    modalContent.classList.add('mt-2')
                }
            }

            const printContent = document.getElementById('modal_content_caixa_report_bobina');

            if (printContent) {
                // Abrir uma nova aba
                const printWindow = window.open('novaJanela', 'width=800,height=400', '_blank');

                if (printWindow) {
                    // Escrever o conteúdo na nova aba
                    printWindow.document.open();
                    printWindow.document.write(`
                                                <html>
                                                    <head>
                                                        <title>Impressão</title>
                                                        <script src="https://cdn.tailwindcss.com"></script>
                                                    </head>
                                                    <body>${printContent.innerHTML}</body>
                                                </html>
                                            `);
                    printWindow.document.close();

                    if (typeof closeModalEvent === 'function') {
                        closeModalEvent();
                    }

                } else {
                    console.error("Não foi possível abrir uma nova aba para impressão.");
                }
            } else {
                console.error("Elemento do modal não encontrado.");
            }

            /*
            const modalElement = document.getElementById('modal_content_caixa_report_bobina')?.innerHTML;

            if (modalElement) {
                // Cria um iframe invisível
                const iframe = document.createElement('iframe');
                iframe.style.position = 'absolute';
                iframe.style.width = '0';
                iframe.style.height = '0';
                iframe.style.border = 'none';

                // Adiciona o iframe ao body
                document.body.appendChild(iframe);

                // Aguarda o carregamento do iframe
                iframe.onload = () => {
                    const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;

                    if (iframeDoc) {
                        // Escreve o conteúdo do modal no iframe com o link do Tailwind
                        iframeDoc.open();
                        iframeDoc.write(`
              <html>
                <head>
                  <title>Imprimir</title>
                  <!-- Link para o CSS do Tailwind -->
                  <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
                </head>
                <body>
                  ${modalElement}
                </body>
              </html>
            `);
                        iframeDoc.close();

                        // Espera o conteúdo carregar e inicia a impressão
                        setTimeout(() => {
                            iframe.contentWindow?.focus();
                            iframe.contentWindow?.print();

                            // Remove o iframe após a impressão
                            document.body.removeChild(iframe);

                            // Fecha o modal
                            if (typeof closeModalEvent === 'function') {
                                closeModalEvent();
                            }
                        }, 500); // Pequeno delay para garantir o carregamento
                    } else {
                        console.error('iframeDoc não encontrado.');
                    }
                };
            } else {
                console.error('Elemento com ID "modal_caixa_report_bobina" não encontrado.');
            }
                */

        } else {

            let modal = document.getElementById('modal_caixa_report_bobina');
            let modalContent = document.getElementById('modal_content_caixa_report_bobina');

            if (modal) {
                modal.style.visibility = 'hidden';

                if (modalContent) {
                    modalContent.classList.add('mt-[-2000px]');
                    modalContent.classList.remove('mt-2');
                }
            }


        }

    }, [visible])

    return (

        <div id="modal_caixa_report_bobina" style={{ visibility: "hidden"}} className="fixed top-0 bottom-0 left-0 right-0 z-40 flex justify-center transition-all duration-300">

            <div id="modal_content_caixa_report_bobina" style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', height: 'auto', borderRadius: '0.5rem', marginTop: '-2000px', transition: 'all 0.3s' }}>

                <div style={{ width: '80mm', minHeight: '500px', height: 'auto', backgroundColor: 'white', paddingLeft: '0.25rem', paddingRight: '0.25rem', padding: '0.5rem' }}>

                    <div id="modal_content_empresa" style={{ width: '100%' }}>
                        <div style={{ minHeight: '20px', height: 'auto', width: '100%', borderBottom: '1px solid black', display: 'flex', flexDirection: 'column', fontSize: '12px', padding: '0.25rem', textAlign: 'center'}}>
                            <span  style={{ marginBottom: '3px' }}>{empresa.razao}</span>
                            <span  style={{ marginBottom: '3px' }}>{'CNPJ: ' + Funcoes.FormatDoc(empresa.cnpj_cpf)}</span>
                            <span  style={{ marginBottom: '3px' }}>{empresa.endereco + ', ' + empresa.numero + ', ' + empresa.bairro}</span>
                            <span>{empresa.cidade + '-' + empresa.uf}</span>
                        </div>
                    </div>

                    <div id="modal_content_titulo" style={{ width: '100%' }}>
                        <div style={{ minHeight: '20px', height: 'auto', width: '100%', borderBottom: '1px solid black', display: 'flex', flexDirection: 'column', fontSize: '16px', padding: '0.25rem', textAlign: 'center' }}>
                            <span style={{ fontWeight: '600' }}>{'FECHAMENTO DE CAIXA'}</span>
                        </div>
                    </div>

                    <div id="modal_content_data" style={{ width: '100%' }}>
                        <div style={{ minHeight: '20px', height: 'auto', width: '100%', borderBottom: '1px solid black', display: 'flex', flexDirection: 'column', fontSize: '12px', paddingTop: '4px', paddingBottom: '4px', textAlign: 'start' }}>
                            <span>{'Data: ' + (moment(data).format('DD/MM/YYYY') || '') + ' a ' + (moment(data).format('DD/MM/YYYY') || '')}</span>
                        </div>
                    </div>

                    <div id="modal_content_segundo_titulo" style={{ width: '100%' }}>
                        <div style={{ minHeight: '20px', height: 'auto', width: '100%', borderBottom: '1px solid black', display: 'flex', flexDirection: 'column', fontSize: '14px', padding: '0.25rem', textAlign: 'center' }}>
                            <span style={{ fontWeight: '600' }}>{'Suprimentos e Sangrias'}</span>
                        </div>
                    </div>

                    <table style={{ marginTop: '0.25rem', width: '100%' }}>
                        <thead id="dadosTituloSupSangria">
                            <tr>
                                <th style={{ fontSize: '10px', width: '20%', textAlign: 'start' }}>Data</th>
                                <th style={{ fontSize: '10px', width: '50%', textAlign: 'start', paddingLeft: '0.25rem', paddingRight: '0.25rem' }}>Descrição</th>
                                <th style={{ fontSize: '10px', width: '30%', textAlign: 'end' }}>Valor</th>
                            </tr>
                        </thead>
                        <tbody id="dadosSupSangria">
                            {supSangria?.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ fontSize: '10px' }}>{moment(item.dh_insert).format("DD/MM/YYYY") || ''}</td>
                                    <td style={{ fontSize: '10px', paddingLeft: '0.25rem', paddingRight: '0.25rem' }}>{item.observacao}</td>
                                    <td style={{ fontSize: '10px', display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%' }}>{item.tipo === 'A' ? '-' + Funcoes.numberFormat(item.valor || 0, 'decimal') : Funcoes.numberFormat(item.valor || 0, 'decimal')}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div id="modal_content_total_sup_sangria" style={{ width: '100%' }}>
                        <div style={{ minHeight: '20px', height: 'auto', width: '100%', borderBottom: '1px solid black', display: 'flex', flexDirection: 'row', padding: '0rem', textAlign: 'start' }}>
                            <span style={{ fontSize: '14px', fontWeight: '600' }}>{'TOTAL: '}</span>
                            <span style={{ fontSize: '10px', fontWeight: '600', display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%' }}>{Funcoes.numberFormat(totGeralSupSangria, 'decimal') || '0.00'}</span>
                        </div>
                    </div>

                    <div id="modal_content_terceiro_titulo" style={{ width: '100%' }}>
                        <div style={{ minHeight: '20px', height: 'auto', width: '100%', borderBottom: '1px solid black', display: 'flex', flexDirection: 'column', fontSize: '14px', padding: '0.25rem', textAlign: 'center' }}>
                            <span style={{ fontWeight: '600' }}>{'Resumo das Vendas'}</span>
                        </div>
                    </div>

                    <table style={{ marginTop: '0.25rem', width: '100%' }}>
                        <tbody id="dadosVendas">
                            {resVendas?.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ fontSize: '10px', textAlign: 'start' }}>{item.descricao}</td>
                                    <td style={{ fontSize: '10px', display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%' }}>{Funcoes.numberFormat(item.valor || 0, 'decimal')}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div id="modal_content_total_vendas" style={{ width: '100%' }}>
                        <div style={{ minHeight: '20px', height: 'auto', width: '100%', borderBottom: '1px solid black', display: 'flex', flexDirection: 'row', padding: '0rem', textAlign: 'start' }}>
                            <span style={{ fontSize: '14px', fontWeight: '600' }}>{'TOTAL: '}</span>
                            <span style={{ fontSize: '10px', fontWeight: '600', display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%' }}>{Funcoes.numberFormat(totGeralVendas, 'decimal') || '0.00'}</span>
                        </div>
                    </div>

                    <div id="modal_content_quarto_titulo" style={{ width: '100%' }}>
                        <div style={{ minHeight: '20px', height: 'auto', width: '100%', borderBottom: '1px solid black', display: 'flex', flexDirection: 'column', fontSize: '14px', padding: '0.25rem', textAlign: 'center' }}>
                            <span style={{ fontWeight: '600' }}>{'Resumo dos Recebimentos'}</span>
                        </div>
                    </div>

                    <table id="modal_content_dados_recebimentos" style={{ marginTop: '0.25rem', width: '100%' }}>
                        <tbody>
                            {resRecebimentos?.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ fontSize: '10px', textAlign: 'start' }}>{item.descricao}</td>
                                    <td style={{ fontSize: '10px', display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%' }}>{Funcoes.numberFormat(item.valor || 0, 'decimal')}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div id="modal_content_total_recebimentos" style={{ width: '100%' }}>
                        <div style={{ minHeight: '20px', height: 'auto', width: '100%', borderBottom: '1px solid black', display: 'flex', flexDirection: 'row', padding: '0rem', textAlign: 'start' }}>
                            <span style={{ fontSize: '14px', fontWeight: '600' }}>{'TOTAL: '}</span>
                            <span style={{ fontSize: '10px', fontWeight: '600', display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%' }}>{Funcoes.numberFormat(totGeralRecebimentos, 'decimal') || '0.00'}</span>
                        </div>
                    </div>

                    <div id="modal_content_quinto_titulo" style={{ width: '100%' }}>
                        <div style={{ minHeight: '20px', height: 'auto', width: '100%', borderBottom: '1px solid black', display: 'flex', flexDirection: 'column', fontSize: '14px', padding: '0.25rem', textAlign: 'center' }}>
                            <span style={{ fontWeight: '600' }}>{'Resumo do Caixa'}</span>
                        </div>
                    </div>

                    <div id="modal_content_dados_apuracao" style={{ width: '100%', display: 'flex', flexDirection: 'column', paddingTop: '0.25rem', paddingBottom: '0.25rem' }}>

                        <div style={{ minHeight: '20px', height: 'auto', width: '100%', display: 'flex', flexDirection: 'row', textAlign: 'start' }}>
                            <span style={{ fontSize: '10px', fontWeight: '600', width: '55%' }}>{'Suprimentos (+): '}</span>
                            <span style={{ fontSize: '10px', fontWeight: '600', display: 'flex', justifyContent: 'end', alignItems: 'center', width: '45%' }}>{Funcoes.numberFormat(totSuprimentos, 'decimal') || '0.00'}</span>
                        </div>

                        <div style={{ minHeight: '20px', height: 'auto', width: '100%', display: 'flex', flexDirection: 'row', textAlign: 'start' }}>
                            <span style={{ fontSize: '10px', fontWeight: '600', width: '55%' }}>{'Vendas no Dinheiro (+): '}</span>
                            <span style={{ fontSize: '10px', fontWeight: '600', display: 'flex', justifyContent: 'end', alignItems: 'center', width: '45%' }}>{Funcoes.numberFormat(totDinheiroVendas, 'decimal') || '0.00'}</span>
                        </div>

                        <div style={{ minHeight: '20px', height: 'auto', width: '100%', display: 'flex', flexDirection: 'row', textAlign: 'start' }}>
                            <span style={{ fontSize: '10px', fontWeight: '600', width: '55%' }}>{'Recebimentos no Dinheiro (+): '}</span>
                            <span style={{ fontSize: '10px', fontWeight: '600', display: 'flex', justifyContent: 'end', alignItems: 'center', width: '45%' }}>{Funcoes.numberFormat(totDinheiroRecebimentos, 'decimal') || '0.00'}</span>
                        </div>

                        <div style={{ minHeight: '20px', height: 'auto', width: '100%', display: 'flex', flexDirection: 'row', textAlign: 'start' }}>
                            <span style={{ fontSize: '10px', fontWeight: '600', width: '55%' }}>{'Retiradas (-): '}</span>
                            <span style={{ fontSize: '10px', fontWeight: '600', display: 'flex', justifyContent: 'end', alignItems: 'center', width: '45%' }}>{Funcoes.numberFormat(totSangrias, 'decimal') || '0.00'}</span>
                        </div>

                    </div>

                    <div id="modal_content_total_caixa" style={{ width: '100%' }}>
                        <div style={{ minHeight: '20px', height: 'auto', width: '100%', borderBottom: '1px solid black', display: 'flex', flexDirection: 'row', padding: '0rem', textAlign: 'start' }}>
                            <span style={{ fontSize: '14px', fontWeight: '600' }}>{'TOTAL: '}</span>
                            <span style={{ fontSize: '10px', fontWeight: '600', display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%' }}>{Funcoes.numberFormat(totGeralApuracao, 'decimal') || '0.00'}</span>
                        </div>
                    </div>
                </div>

            </div>


        </div>

    )

}